<script>
  import { onMount } from 'svelte';
  import responsive from '../utils/responsive';

  import PageHero from '$lib/page/Hero.svelte';
  import Back from '$lib/singlePortfolio/Back.svelte';
  import VacancyMainFacts from '$lib/vacancy/VacancyMainFacts.svelte';
  import Other from '$lib/vacancy/Other.svelte';
  import TwoStripes from '$lib/default/TwoStripes.svelte';
  import Details from '$lib/vacancy/Details.svelte';
  import CallToAction from '$lib/vacancy/CallToAction.svelte';
  import Seo from '$lib/Seo.svelte';
  import Faq from '$lib/faq/Index.svelte';

  export let page_hero;
  export let facts;
  export let details;
  export let cta;
  export let other;
  export let back;
  export let seo;
  export let faq;
  export let wysiwyg;

  let isDesktop, innerWidth;

  function handleScreenSize() {
    isDesktop = innerWidth > responsive.m;
  }

  onMount(() => {
    handleScreenSize();
  });
</script>

<svelte:window bind:innerWidth on:resize={handleScreenSize} />

<div class="page-single-vacancy">
  {#if page_hero}
    <PageHero hero={page_hero} />
  {/if}
  {#if facts}
    <VacancyMainFacts {facts} />
  {/if}
  <div class="container container--medium">
    <div class="inner-container">
      {#if details && wysiwyg}
        <Details
          {details}
          featuredImage={details.featuredImage}
          content1={wysiwyg.content1}
          content2={wysiwyg.content2}
        />
      {/if}
      {#if !isDesktop && cta}
        <CallToAction {cta} link={cta.link} />
      {/if}
      <div class="inner-container__two-stripes">
        <TwoStripes />
      </div>
    </div>
  </div>
</div>

{#if isDesktop && cta}
  <CallToAction {cta} link={cta.link} />
{/if}
{#if other}
  <Other {other} />
{/if}
<Back {back} />

{#if seo}
  <Seo {seo} />
{/if}
{#if faq}
  <Faq {faq} />
{/if}

<style lang="scss">
  .container,
  .container--medium {
    @include resp-max('m') {
      width: 100%;
    }
  }
  .inner-container {
    border-radius: 20px;
    padding: 10rem 24rem;
    --black: 0, 0, 0;
    box-shadow: 3px 3px rgba(var(--black), 0.02);
    background-color: rgb(var(--white));
    margin-top: 10rem;
    position: relative;

    @include resp-max('xl') {
      padding: 10rem 12rem;
    }

    @include resp-max('l') {
      padding: 10rem 5rem;
    }

    @include resp-max('m') {
      margin-top: 7rem;
      padding: 5rem 4rem;
    }

    @include resp-max('s') {
      margin-top: 5rem;
    }

    &__two-stripes {
      position: absolute;
      bottom: 0;
      right: 4.7rem;

      @include resp-max('m') {
        right: 50%;
        transform: translate(50%);
        max-width: 2.1rem;
      }
    }
  }
</style>
